import cntl from "cntl";
import PropTypes from "prop-types";
import TabButton from "./TabButton";
import { useState, useMemo } from "react";
import { SIZE } from "../constants/index";

const propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  className: PropTypes.string,
  ariaSelected: PropTypes.string,
  ariaControls: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function TabButtonPrimary({
  id,
  size,
  label,
  onClick,
  children,
  tabIndex,
  className,
  isDisabled,
  ariaControls,
  ariaSelected,
}) {
  const [padding, setPadding] = useState("");

  const tabButtonPrimaryCn = () => cntl`
    focus:ring
    focus:bg-white
    focus:text-grey-500
    focus:ring-offset-0
    focus:ring-primary-100
    ${padding}
    ${
      ariaSelected === "true"
        ? cntl`bg-primary-50 text-primary-700 focus:text-primary-700 focus:bg-primary-50`
        : !!!isDisabled && cntl`bg-transparent text-grey-500 hover:bg-primary-50 hover:text-primary-700`
    }
    ${className ? className : undefined}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setPadding("px-3 py-2");
        break;
      case SIZE.md:
        setPadding("px-3.5 py-2.5");
        break;
      default:
        setPadding("px-3 py-2");
        break;
    }
  }, [size]);

  return (
    <TabButton
      id={id}
      size={size}
      label={label}
      onClick={onClick}
      tabIndex={tabIndex}
      isDisabled={isDisabled}
      ariaControls={ariaControls}
      ariaSelected={ariaSelected}
      className={tabButtonPrimaryCn()}
    >
      {children}
    </TabButton>
  );
}

TabButtonPrimary.propTypes = propTypes;
export default TabButtonPrimary;
